import { useCallback, useEffect, useState } from 'react';
import { CHANGELOG } from '../../../shared/config/changelog';

const STORAGE_KEY = 'changelog_seen_date';

/** Дата самой свежей записи — с ней сравниваем то, что пользователь уже видел. */
const latestDate = CHANGELOG[0]?.date ?? '';

/**
 * Что пользователь ещё не читал. Храним в localStorage: список изменений —
 * личная мелочь, ради неё не стоит ходить на сервер.
 */
export function useChangelogSeen(): { hasUnread: boolean; markSeen: () => void } {
  const [seenDate, setSeenDate] = useState<string>(latestDate);

  useEffect(() => {
    try {
      setSeenDate(localStorage.getItem(STORAGE_KEY) ?? '');
    } catch {
      // Приватное окно или запрет на хранилище — молча считаем всё прочитанным.
      setSeenDate(latestDate);
    }
  }, []);

  const markSeen = useCallback(() => {
    setSeenDate(latestDate);
    try {
      localStorage.setItem(STORAGE_KEY, latestDate);
    } catch {
      // Не смогли запомнить — точка просто загорится в следующий раз.
    }
  }, []);

  return { hasUnread: latestDate !== '' && seenDate < latestDate, markSeen };
}
